import {CommonStatus} from "@/enums/status";

export class CustomerParams {
    page? = 1;
    limit? = 100;
    search?: string;
    status? = CommonStatus.Active;
    type?: number;
    onlyParent?: number;
}

export class InsuranceFeeParams {
    priceMark?: number = 0;
    minPrice?: number = 0;
    freightAboveByPercent?: number = 0;
}
